export default "__VITE_ASSET__tHBs1s5Y__"